import React, {useContext} from "react";
import {CreateDeliveryContext} from "../../CreateDeliveryRequest";
import {OrderInformationContainer} from "./OrderInformation.styles";
import {Button, Col, Row} from "antd";
import {OrderBlock} from "./orderBlock/OrderBlock";
import {PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

export const OrderInformation = () => {
    const {orderList, createOrder} = useContext(CreateDeliveryContext);
    const {t} = useTranslation(["newRequest"]);
    return (
        <OrderInformationContainer>
            <Row style={{width: "100%"}}>
                {orderList.map((order, index) => {
                    return (
                        <Col key={index} span="24">
                            <OrderBlock
                                order={order}
                                index={index}
                                isLast={index === orderList.length - 1}
                            />
                        </Col>
                    );
                })}
                <Button
                    onClick={() => createOrder()}
                    style={{width: "100%", marginTop: "20px"}}
                    icon={<PlusOutlined />}
                >
                    {t("newRequest.actions.addOrder", {ns: "newRequest"})}
                </Button>
            </Row>
        </OrderInformationContainer>
    );
};
